import queryString from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { CheckoutLayout } from 'common/components/layout';
import Footer from 'common/components/layout/Footer';
import { logEvent } from 'common/helpers/analytics';
import { getNextClubPackageByClubId } from 'redux/clubPackages/actions';
import { getClubPackageByClubId } from 'redux/clubPackages/reducers';
import {
  updateClubSignup,
  createClubSignup,
  checkoutStep
} from 'redux/clubSignup/actions';
import { getClubBySlug } from 'redux/clubs/reducers';

import EditStep from './EditStep';
import ClubSummary from './components/ClubSummary';
import ContentSummary from './components/ContentSummary';
import Header from './components/Header';
import Message from './components/Message';
import MobileToggleSummary from './components/MobileToggleSummary';
import { calculateStep, editStep } from './helpers';

class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSummaryVisibleOnMobile: false,
      step: 'customer',
      isLoaded: false
    };
    if (props.clubSignup.data) {
      props.checkoutStep('customer');
    }
  }

  componentDidMount() {
    const { props } = this;
    const { slug } = props;
    props.createClubSignup(slug);
    if (props.club) {
      props.getNextClubPackageByClubId(props.club.id);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { props } = this;
    if (!nextProps.clubSignup.isFetching && props.clubSignup.isFetching) {
      const { deliveryMethod } = queryString.parse(props.location.search);
      let step = calculateStep(nextProps.clubSignup);
      if (deliveryMethod && deliveryMethod === 'Pickup') {
        step = 'customer';
      }
      props.location.search = '';

      this.setState({ step }, () => {
        if (nextProps.clubSignup.data) {
          props.checkoutStep(step, nextProps.clubSignup.data);
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { props, state } = this;
    if (!state.isLoaded) {
      logEvent('ClubSignup', 'V1 Start');
      this.setState({ isLoaded: true });
    }
    if (!prevProps.club && props.club) {
      props.getNextClubPackageByClubId(props.club.id);
    }
  }

  handleEdit = (step) => {
    const { props } = this;
    const newStep = editStep(props.clubSignup, step);
    if (newStep === 'account' && props.customer.data) {
      this.setState({ step: 'payment' }, () => {
        props.checkoutStep('payment');
      });
    } else {
      this.setState({ step: newStep }, () => {
        props.checkoutStep(newStep);
      });
    }
  };

  toggleMobileSummary = () => {
    const { isSummaryVisibleOnMobile } = this.state;
    this.setState({ isSummaryVisibleOnMobile: !isSummaryVisibleOnMobile });
  };

  render() {
    const { settings, customer, club, clubSignup, clubPackage } = this.props;
    const { isSummaryVisibleOnMobile } = this.state;
    const { step } = this.state;
    return (
      <CheckoutLayout title="Club Signup">
        <MobileToggleSummary
          onToggleMobile={this.toggleMobileSummary}
          settings={settings}
        />

        <div className="c7-checkout">
          <ClubSummary
            club={club}
            clubPackage={clubPackage}
            clubSignup={clubSignup.data}
            isSummaryVisibleOnMobile={isSummaryVisibleOnMobile}
            page="Signup"
            settings={settings}
          />

          <div className="c7-checkout__main">
            <Header
              step={step}
              customer={customer.data}
              onMenuClick={this.handleEdit}
              settings={settings}
            />

            <div className="c7-checkout__content">
              <Message settings={settings} />
              <ContentSummary
                club={club}
                customer={customer.data}
                clubSignup={clubSignup.data}
                onEdit={this.handleEdit}
                currentStep={step}
                settings={settings}
              />
              <EditStep
                clubSignup={clubSignup.data}
                club={club}
                customer={customer.data}
                step={step}
                onEdit={this.handleEdit}
              />
            </div>

            <Footer settings={settings} />
          </div>
        </div>
      </CheckoutLayout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let clubPackage;
  const club = getClubBySlug(state.club, ownProps.slug);
  if (club) {
    clubPackage = getClubPackageByClubId(state.clubPackage, club.id);
  }
  return {
    club,
    clubPackage,
    clubSignup: state.clubSignup,
    customer: state.customer,
    settings: state.setting
  };
};

export default withRouter(
  connect(mapStateToProps, {
    updateClubSignup,
    createClubSignup,
    getNextClubPackageByClubId,
    checkoutStep
  })(Signup)
);
